/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @mui/material components
import { Drawer, useMediaQuery, List, ListItem, ListItemText, Icon, useTheme, Box } from "@mui/material";
// core components
import AdminNavbarLinks from "../Navbars/AdminNavbarLinks.jsx";

import styles from "../assets/jss/material-dashboard-react/components/sidebarStyle.js";


export default function Sidebar(props) {
  const theme = useTheme();
  //const classes = styles(theme);
  // verifies if routeName is the one active (in browser input)
   const activeRoute = (routeName) =>
    window.location.href.indexOf(routeName) > -1;

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { color, logo, image, logoText, routes } = props;
  const listContent = (showText) => (
      <List sx={{ padding: 0 }}>
        {routes
          .filter((prop) => prop.layout === "/admin" && prop.icon !== "None")
          .map((prop, key) => {
            const isActive = activeRoute(prop.layout + prop.path);
            const listItemColor = isActive ? color : "inherit";
            const whiteFont = isActive ? "#FFF" : "#333";
  
            return (
              <NavLink
                to={prop.layout + prop.path}
                key={key}
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  button
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: whiteFont,
                    backgroundColor: isActive ? `${color}.main` : "transparent",
                    "&:hover": {
                      backgroundColor: `${color}.light`
                    }
                  }}
                >
                  {typeof prop.icon === "string" ? (
                    <Icon sx={{ mr: showText ? 2 : 0 }}>{prop.icon}</Icon>
                  ) : (
                    <prop.icon sx={{ mr: showText ? 2 : 0 }} />
                  )}
                  {showText && (
                    <ListItemText
                      primary={prop.name}
                      sx={{ color: whiteFont }}
                      disableTypography
                    />
                  )}
                </ListItem>
              </NavLink>
            );
          })}
      </List>
    );
  
     const brand = (
      <Box
        sx={{
          padding: 2,
          fontWeight: "bold",
          textAlign: "center",
          color: "#333"
        }}
      >
        CT-Onlinq
      </Box>
    );
  
      const drawerContent = (
      <Box sx={{ position: "relative", height: "100%", width: 250 }}>
        {brand}
        <Box sx={{ px: 2 }}>
          <AdminNavbarLinks routes={routes} type="teacher" />
          {listContent(true)}
        </Box>
        {image && (
          <Box
            sx={{
              position: "absolute",
              height: "100%",
              width: "100%",
              top: 0,
              left: 0,
              backgroundImage: `url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: 0.1,
              zIndex: -1
            }}
          />
        )}
      </Box>
    );
  return (
    <>
      {isMobile && (
        <Drawer
          variant="temporary"
          anchor="right"
          open={props.open}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true
          }}
        >
          {drawerContent}
        </Drawer>
      )}
    </>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};
